import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    activeMenu: null
  },
  mutations: {
    setActiveMenu (state, activeMenu) {
      state.activeMenu = activeMenu
    }
  }
})

export default store
